"use client";

import { usePathname } from "@/i18n/navigation";

export const NotFoundAttemptedPath = ({ label }: { label: string }) => {
  const pathname = usePathname();

  return (
    <div className="border-border bg-muted/35 rounded-lg border px-3 py-2 text-left">
      <p className="text-muted-foreground text-xs font-medium">{label}</p>
      <p className="mt-1 truncate font-mono text-sm" translate="no">
        {pathname}
      </p>
    </div>
  );
};
